"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TREE_LEVEL_COLORS = void 0;
exports.TREE_LEVEL_COLORS = ['red', 'green', 'blue', 'magenta'];
